import React, { useState, useEffect, useCallback } from "react";
import "moment/locale/sv";
import "moment/locale/de";
import moment from "moment";
export type Locale = "sv" | "en";
type User = {
  locale: Locale;
  lang?:string;
  changeLocale: (newLocale: Locale) => void;
  hasAccessToModule: (module: Module) => boolean;
  hasAccessToFeature: (feature: Feature, accessLevel: AccessLevel) => boolean;
  userImpersonation?: string;
  impersonateUser: (email?: string) => void;
};
type clientDetails={
  id:number;
  name:string;
  email:string;
  organisationId:string;
  mobile:string;
  ftpUserName:string;
  ftpPassword:string;
  ftpDirectory:string;
}
type detail={
  client:any;
}
export enum Module {
  LawPortal = 1,
  Administration = 2,
  Organization = 3,
}
export enum AdminFeature {
  Administrate = 0,
}
export enum LawPortalFeature {
  Manage = 1,
  OurLaws = 2,
  OtherRequirements = 4,
  Statistics = 6,
  InviteAptor = 7,
}

export enum OrganizationFeature {
  Manage = 10,
}
export enum UserStatus {
  Invited = 'Pending',
  Active = 'Active',
  Inactive = 'Expire',
}
export enum AccessLevel {
  None = 0,
  Read = 1,
  Manage = 2,
  Administer = 4,
}
type UserFeature = {
  feature: Enumeration & { module: Enumeration };
  accessLevel: Enumeration;
};
type Enumeration = {
  value: number;
  displayName: string;
  name: string;
};
export const IMPERSONATION_KEY = 'impersonatedAs';
export type SupportInvitation = { id: string; validTo: Date };
type Feature = AdminFeature | LawPortalFeature | OrganizationFeature;
export const useUser = (): User => {
  const [locale, changeLocale] = useState<Locale>("sv");
  const [featureAccess, setFeatureAccess] = useState<UserFeature[]>([]);
  const [userImpersonation, setUserImpersonation] = useState<string | undefined>(
    localStorage.getItem(IMPERSONATION_KEY) || undefined,
  );

  useEffect(() => {
    let lang = JSON.parse(localStorage.getItem("language")!)
    if(lang){
        changeLocale(lang)
    }
    setFeatureAccess([]);
      moment.locale(locale);
     
  }, [locale]);
  const hasAccessToModule = useCallback(
    (module: Module) => {
      return featureAccess.some((feature) => feature.feature.module.value === module);
    },
    [featureAccess],
  );
  const hasAccessToFeature = useCallback(
    (feature: Feature, accessLevel: AccessLevel) => {
      return featureAccess.some((fa) => fa.feature.value === feature && fa.accessLevel.value >= accessLevel);
    },
    [featureAccess],
  );

  const impersonateUser=(impersonateUser?: string) => {
    if (impersonateUser) {
      localStorage.setItem(IMPERSONATION_KEY, JSON.stringify(impersonateUser));
    } else {
      localStorage.removeItem(IMPERSONATION_KEY);
    }
    setUserImpersonation(JSON.stringify(impersonateUser));
  }
  return {
    locale,
    changeLocale,
    hasAccessToModule,
    hasAccessToFeature,
    impersonateUser,
    userImpersonation

  };
};
export const UserContext = React.createContext<User>({
  locale: "sv",
  changeLocale: () => { },
  hasAccessToModule: (_module: Module) => false,
  hasAccessToFeature: (_feature: Feature, _accessLevel: AccessLevel) => false,
  impersonateUser: () => {},
  userImpersonation: '',
});


